import styled from 'styled-components';

import { applyFlexAndCenter, devices, fontWeight } from '@/UI/Styles';

export const Wrapper = styled.div`
  box-sizing: border-box;
  color: ${({ theme }) => theme.palette.white};
  background-color: ${({ theme }) => theme.brandTheme.brand100};
  padding: 17px;
  p {
    color: ${({ theme }) => theme.palette.white};
  }
`;

export const WarningContainer = styled.div`
  box-sizing: border-box;
  ${applyFlexAndCenter()}
  background-color: ${({ theme }) => theme.palette.white20};
  color: ${({ theme }) => theme.palette.white};
  border-radius: 100%;

  svg {
    width: 29px;
    height: 29px;

    @media ${devices.XSmall} {
      font-size: 13.14px;
    }

    @media ${devices['no-mobile']} {
      font-size: 14px;
    }
  }
`;

export const MainContent = styled.div`
  display: flex;
  align-items: center;

  p {
    margin-left: 8px;
    font-weight: ${fontWeight.bold};

    @media ${devices['no-mobile']} {
      margin-left: 12px;
    }
  }
`;

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  column-gap: 4px;
`;
